import angular from "angular";

import { AccountantType, AccountInIndex, Ajax, LegalEntityType, PrimaryPartnerSettings } from "@salaxy/core";

import { SettingsService, UiHelpers } from "../../services";

/**
 * Controller for the accountant settings.
 */
export class AccountantController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1", "SettingsService", "UiHelpers"];


   /** if true, removing accountant is disabled */
   public removalDisabled: boolean;

  constructor(private ajax: Ajax, private settingsService: SettingsService, private uiHelpers: UiHelpers) {
  }

  /**
   * Returns current accountant.
   */
  public get accountant(): PrimaryPartnerSettings {
    if (this.settingsService.current) {
      return this.settingsService.current.partner;
    }
    return null;
  }

  /** Returns accountant main type */
  public get accountantMainType(): "company" | "none" {
    return this.getAccountantMainType(this.accountant);
  }

  /** Shows the edit dialog */
  public showEdit(removalDisabled = false) {
    const accountant: PrimaryPartnerSettings = this.accountant || {
      type: AccountantType.None,
      info: {
        avatar: {},
      },
    };
    const logic = {
      type: this.getAccountantMainType(accountant),
      searchResult: [] as AccountInIndex[],
      isLoading: false,
      removalDisabled,
      selected: this.getAccountantMainType(accountant) == "company" ? accountant.info : null,
      select: (item: PrimaryPartnerSettings, row: AccountInIndex) => {
        item.info = row;
        item.type = AccountantType.PendingPrimaryPartner;
        logic.selected = row;
      },
      reset: (item) => {
        logic.selected = null;
        Object.assign(item, accountant);
      },
      search: (search: string) => {
        logic.isLoading = true;
        return this.ajax.getJSON(`/v03/api/settings/partners?search=${encodeURIComponent(search)}`).then((result) => {
          logic.searchResult = result;
          logic.isLoading = false;
          return logic.searchResult;
        });
      },
    };

    return this.uiHelpers.openEditDialog(
      "salaxy-components/modals/settings/AccountantSelection.html",
      accountant,
      logic,
      "lg").then((dialog) => {
        if (dialog.result === "ok") {
          const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");

          if (logic.type === "none" && (dialog.item.info.avatar.firstName || dialog.item.info.avatar.lastName)) {
            dialog.item.type = AccountantType.None;
            dialog.item.info.avatar.displayName = (dialog.item.info.avatar.firstName + " " + dialog.item.info.avatar.lastName).trim();
            dialog.item.info.avatar.color = "gray";
            dialog.item.info.avatar.entityType = LegalEntityType.Person;
            dialog.item.info.avatar.initials = (((dialog.item.info.avatar.firstName ?? "") + " ")[0].toUpperCase() + ((dialog.item.info.avatar.lastName ?? "") + " ")[0].toUpperCase()).trim();
          }

          this.settingsService.current.partner = dialog.item;
          return this.settingsService.save().then(() => {
            loading.dismiss();
            return;
          });
        }
        else if (dialog.result === "remove") {
          this.settingsService.current.partner = {
            info: {
              avatar: {},
            },
            type: AccountantType.None,
          };
          const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
          return this.settingsService.save().then(() => {
              loading.dismiss();
          });
        }
        else if ( dialog.result === "removePrimaryPartner") {
          this.showConfirmPartnerRemoval();
          return;
        }
      });
  }

  /** Removes pricing partner using confirmation dialog. */
  public showConfirmPartnerRemoval() {
    this.uiHelpers.showConfirm("SALAXY.NG1.AccountantComponent.showConfirmPartnerRemovalTitle", "SALAXY.NG1.AccountantComponent.showConfirmPartnerRemovalDesciption")
      .then((result) => {
        if (result) {
          this.settingsService.current.partner = {
            info: {
              avatar: {},
            },
            type: AccountantType.None,
          };
          const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
          return this.settingsService.save().then(() => {
              loading.dismiss();
          });
        }
      });
  }

  /** Save current accountant. This mainly for email address. */
  public save(): Promise<void> {
    const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
    return this.settingsService.save().then(() => {
      loading.dismiss();
      return;
    });
  }

  private getAccountantMainType(accountant: PrimaryPartnerSettings): "company" | "none" {
    if (!accountant ||
        !accountant.type ||
        accountant.type === AccountantType.Unknown ||
        accountant.type === AccountantType.None) {
      return "none";
    }

    return "company";

  }
}
